module.exports = __webpack_public_path__ + "static/media/instagram_logo_claro.37790f89.webp";